import { Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
const SectionGrid = ({ title, children, dividerSx, ...props }) => {
  return (
    <Grid {...props}>
      <Divider textAlign="left" sx={{ pb: 1, ...dividerSx }}>
        <Typography variant="subtitle2">{title}</Typography>
      </Divider>
      {children}
    </Grid>
  );
};

export default SectionGrid;
